<div class="container"
    [ngClass]="{'is-active':isActive,'edit':!readonly,'border':!tileSettings.hideBorder,'no-border':tileSettings.hideBorder}"
    tabindex="-1" (click)="onContainerClick($event)" (mouseenter)="onMouseenter()" (mouseleave)="onMouseleave()">
    <div *ngIf="!tileSettings.hideHeader" class="header">
        <div class="title-box h3-regular">
            {{name}}
        </div>
        <div class="btn-box gridster-item-content" kendoTooltip tooltipClass="tooltip-adjust-right">
            <ng-container *ngIf="showIcons&&expandable">
                <smart-icon [name]="'tile-'+otherStatus" [title]="otherStatus" class="light" (click)="expand()">
                </smart-icon>
            </ng-container>
            <ng-container *ngIf="icons && icons.length > 0 && showIcons">
                <ng-container *ngFor="let item of icons">
                    <smart-icon *ngIf="!banIcon[item['title']]" [name]="item['icon']" [title]="item['title']"
                        class="light" (click)="iconClick($event,item['icon'])">
                    </smart-icon>
                </ng-container>
            </ng-container>
        </div>
    </div>
    <div *ngIf="contextMenuConfig&&tileSettings.hideHeader&&!isLoading" class="header-float">
        <smart-icon *ngIf="showIcons" [name]="'meatball'" (click)="showContextMenu($event)">
        </smart-icon>
        <tam-context-menu [config]="contextMenuConfig"></tam-context-menu>
    </div>
    <div [ngClass]="{'body-full':tileSettings.hideHeader,'body':!tileSettings.hideHeader, 'margin-top': tileSettings.hideHeader && type===5}"
        loading-spin [isLoading]="isLoading" [loadingSize]="'small'">
        <div class="full-height" #content>
            <ng-template tamDashboardTileContainer></ng-template>
        </div>
    </div>
    <div class="no-data-box" *ngIf="noData"
        [ngClass]="{'no-data-full':tileSettings.hideHeader,'no-data':!tileSettings.hideHeader}">
        There is no data available.
    </div>
</div>